export const OHL = {
    name: 'Dv 128/2',
    voltage: '110',
    regionCode: 'BR',
    stanice: [],
    stubovi: [
        { index: 1, name: 'P-01', lat: 44.375 , lng: 21.9059, sys: 1, portal: true },
        { index: 2, name: '168/1z', lat: 44.3753 , lng: 21.9066, sys: 2},
        { index: 3, name: '168/2z', lat: 44.3778 , lng: 21.9074, sys: 2},
        { index: 4, name: '168/3z', lat: 44.3781 , lng: 21.9075, sys: 2},
        { index: 5, name: '168', lat: 44.3785 , lng: 21.9073, sys: 1},
        { index: 6, name: '167', lat: 44.381 , lng: 21.9059, sys: 1},
        { index: 7, name: '166', lat: 44.3819 , lng: 21.9039, sys: 1},
        { index: 8, name: '165', lat: 44.3825 , lng: 21.9028, sys: 1},
        { index: 9, name: '164', lat: 44.3837 , lng: 21.9002, sys: 1},
        { index: 10, name: '163', lat: 44.3859 , lng: 21.8958, sys: 1},
        { index: 11, name: '162', lat: 44.3866 , lng: 21.8944, sys: 1},
        { index: 12, name: '161', lat: 44.387 , lng: 21.8934, sys: 1},
        { index: 13, name: '160', lat: 44.3883 , lng: 21.8908, sys: 1},
        { index: 14, name: '159', lat: 44.3898 , lng: 21.8877, sys: 1},
        { index: 15, name: '16', lat: 44.3897 , lng: 21.8877, sys: 1},
        { index: 16, name: '15', lat: 44.3904 , lng: 21.8907, sys: 1},
        { index: 17, name: '14', lat: 44.3917 , lng: 21.8922, sys: 1},
        { index: 18, name: '13', lat: 44.3935 , lng: 21.8943, sys: 1},
        { index: 19, name: '12', lat: 44.3948 , lng: 21.8958, sys: 1},
        { index: 20, name: '11', lat: 44.3958 , lng: 21.8971, sys: 1},
        { index: 21, name: '10', lat: 44.3972 , lng: 21.8993, sys: 1},
        { index: 22, name: '9', lat: 44.3981 , lng: 21.9006, sys: 1},
        { index: 23, name: '8', lat: 44.3995 , lng: 21.9026, sys: 1},
        { index: 24, name: '7', lat: 44.4029 , lng: 21.9036, sys: 1},
        { index: 25, name: '6', lat: 44.4048 , lng: 21.9043, sys: 1},
        { index: 26, name: '5', lat: 44.4067 , lng: 21.9057, sys: 1},
        { index: 27, name: '4', lat: 44.4101 , lng: 21.9059, sys: 1},
        { index: 28, name: '3', lat: 44.4116 , lng: 21.9059, sys: 1},
        { index: 29, name: '2', lat: 44.4132 , lng: 21.9088, sys: 1},
        { index: 30, name: '1', lat: 44.4143 , lng: 21.9107, sys: 1},
        { index: 31, name: 'P-02', lat: 44.4147 , lng: 21.9108, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P-01 - 16', position: [{ lat: 44.375 , lng: 21.9059 }, { lat: 44.3753 , lng: 21.9066 }] },
        { name: '16 - 15', position: [{ lat: 44.3753 , lng: 21.9066 }, { lat: 44.3778 , lng: 21.9074 }] },
        { name: '15 - 14', position: [{ lat: 44.3778 , lng: 21.9074 }, { lat: 44.3781 , lng: 21.9075 }] },
        { name: '14 - 168', position: [{ lat: 44.3781 , lng: 21.9075 }, { lat: 44.3785 , lng: 21.9073 }] },
        { name: '168 - 167', position: [{ lat: 44.3785 , lng: 21.9073 }, { lat: 44.381 , lng: 21.9059 }] },
        { name: '167 - 166', position: [{ lat: 44.381 , lng: 21.9059 }, { lat: 44.3819 , lng: 21.9039 }] },
        { name: '166 - 165', position: [{ lat: 44.3819 , lng: 21.9039 }, { lat: 44.3825 , lng: 21.9028 }] },
        { name: '165 - 164', position: [{ lat: 44.3825 , lng: 21.9028 }, { lat: 44.3837 , lng: 21.9002 }] },
        { name: '164 - 163', position: [{ lat: 44.3837 , lng: 21.9002 }, { lat: 44.3859 , lng: 21.8958 }] },
        { name: '163 - 162', position: [{ lat: 44.3859 , lng: 21.8958 }, { lat: 44.3866 , lng: 21.8944 }] },
        { name: '162 - 161', position: [{ lat: 44.3866 , lng: 21.8944 }, { lat: 44.387 , lng: 21.8934 }] },
        { name: '161 - 160', position: [{ lat: 44.387 , lng: 21.8934 }, { lat: 44.3883 , lng: 21.8908 }] },
        { name: '160 - 159', position: [{ lat: 44.3883 , lng: 21.8908 }, { lat: 44.3898 , lng: 21.8877 }] },
        { name: '159 - 16', position: [{ lat: 44.3898 , lng: 21.8877 }, { lat: 44.3897 , lng: 21.8877 }] },
        { name: '16 - 15', position: [{ lat: 44.3897 , lng: 21.8877 }, { lat: 44.3904 , lng: 21.8907 }] },
        { name: '15 - 14', position: [{ lat: 44.3904 , lng: 21.8907 }, { lat: 44.3917 , lng: 21.8922 }] },
        { name: '14 - 13', position: [{ lat: 44.3917 , lng: 21.8922 }, { lat: 44.3935 , lng: 21.8943 }] },
        { name: '13 - 12', position: [{ lat: 44.3935 , lng: 21.8943 }, { lat: 44.3948 , lng: 21.8958 }] },
        { name: '12 - 11', position: [{ lat: 44.3948 , lng: 21.8958 }, { lat: 44.3958 , lng: 21.8971 }] },
        { name: '11 - 10', position: [{ lat: 44.3958 , lng: 21.8971 }, { lat: 44.3972 , lng: 21.8993 }] },
        { name: '10 - 9', position: [{ lat: 44.3972 , lng: 21.8993 }, { lat: 44.3981 , lng: 21.9006 }] },
        { name: '9 - 8', position: [{ lat: 44.3981 , lng: 21.9006 }, { lat: 44.3995 , lng: 21.9026 }] },
        { name: '8 - 7', position: [{ lat: 44.3995 , lng: 21.9026 }, { lat: 44.4029 , lng: 21.9036 }] },
        { name: '7 - 6', position: [{ lat: 44.4029 , lng: 21.9036 }, { lat: 44.4048 , lng: 21.9043 }] },
        { name: '6 - 5', position: [{ lat: 44.4048 , lng: 21.9043 }, { lat: 44.4067 , lng: 21.9057 }] },
        { name: '5 - 4', position: [{ lat: 44.4067 , lng: 21.9057 }, { lat: 44.4101 , lng: 21.9059 }] },
        { name: '4 - 3', position: [{ lat: 44.4101 , lng: 21.9059 }, { lat: 44.4116 , lng: 21.9059 }] },
        { name: '3 - 2', position: [{ lat: 44.4116 , lng: 21.9059 }, { lat: 44.4132 , lng: 21.9088 }] },
        { name: '2 - 1', position: [{ lat: 44.4132 , lng: 21.9088 }, { lat: 44.4143 , lng: 21.9107 }] },
        { name: '1 - P-02', position: [{ lat: 44.4143 , lng: 21.9107 }, { lat: 44.4147 , lng: 21.9108 }] }
    ]
}
